module.exports = __webpack_public_path__ + "img/Base@2x.07468d58.png";